import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class={{this.style}} data-test-no-content={{@dataTestValue}}>\n  {{yield}}\n</div>", {
  moduleName: "ui-kit/components/no-content-message/index.hbs"
});